import gql from 'graphql-tag';


import { GetJobReviewInboxQuery } from './initialJobStateQuery';
import { querySelector } from '../../../utils';


const UpdateJobState = gql`
  mutation UpdateJobState($input: JobSetStateInput!) {
    job_set_state(input: $input) {
      id
      state
      all_reviewed
    }
  }
`;


const updateJobStateApi = async (client, jobId, jobState, queryVariables) => {
  const variables = {
    input: {
      id: jobId,
      state: jobState,
    },
  };

  const options = {
    mutation: UpdateJobState,
    variables,
    refetchQueries: [
      { query: GetJobReviewInboxQuery, variables: queryVariables },
    ],
  };

  const cachedQueryResults = client.readQuery({
    query: GetJobReviewInboxQuery,
    variables: queryVariables,
  });
  const oldCollection = querySelector(cachedQueryResults, '$.all_jobs.edges[*].node', []);
  const result = await client.mutate(options);

  return {
    oldCollection,
    result,
  };
};


export default updateJobStateApi;
